export default function setupAccordion() {
  const accordions = document.querySelectorAll('.accordion__toggle');

  if (accordions.length) {
    accordions.forEach((accordion) => {
      const item = accordion.closest('.accordion__item');
      if (item) {
        syncAccordionState(item, accordion.getAttribute('aria-expanded') === 'true' || item.classList.contains('is-active'));
      }

      accordion.addEventListener('click', toggleAccordion);
    });
  }

  document.body.addEventListener('click', (e) => {
    document.querySelectorAll('.accordion__item.is-active[data-close-on-defocus]').forEach((item) => {
      if (e.target.closest('.accordion__item') === item) {
        return;
      }
      syncAccordionState(item, false);
    });
  });

  function syncAccordionState(item, expanded) {
    item.classList.toggle('is-active', expanded);

    const toggle = item.querySelector('.accordion__toggle');
    toggle?.setAttribute('aria-expanded', String(expanded));

    const controlledId = toggle?.getAttribute('aria-controls');
    if (!controlledId) {
      return;
    }

    const controlledElement = document.getElementById(controlledId);
    controlledElement?.setAttribute('aria-hidden', String(!expanded));
    controlledElement?.toggleAttribute('inert', !expanded);
  }

  function toggleAccordion(el) {
    const link = el.target.closest('.accordion__toggle');
    if (!link) {
      return;
    }

    const currentItem = link.closest('.accordion__item');
    const parent = link.closest('.accordion');
    if (!currentItem || !parent) {
      return;
    }

    const allItems = parent.querySelectorAll('.accordion__item');
    const expanded = link.getAttribute('aria-expanded') !== 'true';
    syncAccordionState(currentItem, expanded);

    allItems.forEach((item) => {
      if (item !== currentItem) {
        syncAccordionState(item, false);
      }
    });
  }
}
